import type React from 'react';

type ModificationItemContentProps = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

export const ModificationItemContent = ({
  icon,
  children,
}: ModificationItemContentProps) => {
  return (
    <div className="grow shrink basis-full flex items-center gap-2.5 min-w-0">
      {icon && <div className="shrink-0">{icon}</div>}
      {children}
    </div>
  );
};
